import { render } from "./AddonView.vue?vue&type=template&id=50cb883d&scoped=true&ts=true"
import script from "./AddonView.vue?vue&type=script&lang=ts"
export * from "./AddonView.vue?vue&type=script&lang=ts"

import "./AddonView.vue?vue&type=style&index=0&id=50cb883d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb883d"]])

export default __exports__